import { IClassicWidgetBlock } from '../../../entities';

export interface IClassicWidgetConfig {
  color: string;
  data: IClassicWidgetBlock;
  gradient: string[];
  title: string;
}
